import React, { useContext, useState } from 'react';
// import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import ButtonBase from '@material-ui/core/ButtonBase';
import ClassNames from 'classnames';
import useWindowSize from 'components/useWindowSize';
import NavBarContext from '../../navBarContext';
import MostPopular from './MostPopular';
import BlogsContent from './BlogsContent';
import MobileBlogSelector from './MobileBlogSelector';

const useStyles = makeStyles(theme => ({
  root: {
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
    },
    [theme.breakpoints.up('600')]: {
      display: 'flex',
    },
  },
  rightContent: {
    display: 'flex',
    flexDirection: 'column',
    padding: '17px 34px',
    [theme.breakpoints.down('xs')]: {
      padding: '12px 20px',
    },
  },
  header: {
    marginBottom: 26,
    marginRight: 20,
    fontSize: 17,
  },
  lists: {
    marginTop: 28,
    [theme.breakpoints.up('600')]: {
      display: 'flex',
      flexWrap: 'wrap',
      flexDirection: 'row',
      alignItems: 'flex-start',
    },
  },
  image: {
    width: '100%',
    height: 139,
    marginBottom: 6,
    objectFit: 'cover',
  },
  listItem: {
    width: 246,
    marginRight: 21,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  headerSelector: {
    display: 'flex',
  },
  activeHeader: {
    fontFamily: 'MadaBold',
  },
}));

const Types = ['Latest', 'Company Blog', 'Ambassador Blog'];
function Blogs() {
  const classes = useStyles();
  const [type, setType] = useState('Latest');
  const { popularBlogs, sendMixpanelEvent } = useContext(NavBarContext);
  const clickHandler = (name, element) => {
    sendMixpanelEvent('Menu Item - Clicked', {
      type: 'Blogs',
      name,
      element,
    });
  };
  const { width } = useWindowSize();
  const isMobile = width <= 450;
  return (
    <div className={classes.root}>
      <div className={classes.rightContent}>
        <div className={classes.headerSelector} data-test-id="menu-blog-header">
          {isMobile ? (
            <MobileBlogSelector
              activeType={type}
              clickHandler={el => setType(el)}
            />
          ) : (
            Types.map((el, index) => (
              <ButtonBase onClick={() => setType(el)} key={index} disableRipple>
                <Typography
                  className={ClassNames(
                    classes.header,
                    type === el && classes.activeHeader,
                  )}
                  color="textPrimary"
                >
                  {el}
                </Typography>
              </ButtonBase>
            ))
          )}
        </div>
        <BlogsContent type={type} clickHandler={clickHandler} />
      </div>
      <MostPopular data={popularBlogs} clickHandler={clickHandler} />
    </div>
  );
}

export default Blogs;
